import { axiosGet, axiosPost } from '../axios/config';

export const getTermsCondition = (data) => {
  return axiosGet('/app-content/terms-condition', data);
};

export const addTermsCondition = (data) => {
  return axiosPost('/app-content/terms-condition', data);
};
